import GSAP from "gsap";

export default class {
  constructor() {
    this.elements = {
      logoFooter: ".logo_footer",
    };
  }
  footerLogoReveal() {
    window.addEventListener("scroll", () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight) {
        GSAP.to(this.elements.logoFooter, {
          opacity: 1,
          duration: 1.5,
          ease: "power2.out",
        });
      } else {
        GSAP.to(this.elements.logoFooter, {
          opacity: 0,
          duration: 0.6,
          ease: "power2.out",
        });
      }
    });
  }
}
